import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import videoService from "../../services/video/videoService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";

import "./Video.css";

export default function VideoList() {

    const [video, setVideo] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadVideo();
    }, [page, search]);

    const loadVideo = async () => {

        try {

            setLoading(true);

            const response = await videoService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setVideo(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await videoService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadVideo();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Video</h2>

                <Link
                    to="/videos/add"
                    className="btn btn-primary"
                >
                    Add Video
                </Link>
            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Video..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Video</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="4" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    video.length === 0 ?

                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No Videos Found
                                            </td>
                                        </tr>

                                        :

                                        video.map(item => (

                                            <tr key={item.videoId}>

                                                <td>
                                                    {item.title}
                                                </td>

                                                <td>
                                                    {item.category || "-"}
                                                </td>

                                                <td>

                                                    <a
                                                        href={`https://www.youtube.com/watch?v=${item.youtubeVideoId}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View Video
                                                    </a>

                                                </td>

                                                <td>

                                                    {
                                                        item.isActive
                                                            ? <span className="badge bg-success">Active</span>
                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }

                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/videos/edit/${item.videoId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.videoId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}